import { CFImage } from '@/data/portfolio/type/client-index'
import classNames from 'classnames'
import Image from 'next/image'

export type SingleImageProps = {
  image: CFImage
  fullHeight: boolean
  variant?: number
  pr?: boolean
  py?: number
}

export default function SingleImage({ image, fullHeight, variant = 0, pr = false, py = 12 }: SingleImageProps) {
  const imageRatio = image.height / image.width
  return (
    <>
      <div className={classNames('relative flex h-full max-h-[62rem] flex-col justify-center', { 'md:pr-20': pr })}>
        <div
          className={classNames('relative overflow-hidden', {
            imageContainerFullHeight: fullHeight,
            imageContainer: !fullHeight
          })}>
          <Image src={image.url} layout="fill" className="absolute object-cover" objectFit="cover" />
        </div>

        {variant === 1 ? (
          <div
            aria-hidden="true"
            className="absolute top-72 right-0 -z-10 hidden h-96 w-48 rounded-l-full bg-orange-200 md:block"
          />
        ) : null}
      </div>
      <style jsx>
        {`
          .imageContainerFullHeight .imageContainer {
            width: 100%;
            padding-bottom: ${imageRatio * 100}%;
          }
          @media (min-width: 768px) {
            .imageContainerFullHeight {
              padding-bottom: 0;
              min-height: 36rem;
              min-width: calc(36rem / ${imageRatio});
              height: calc(100vh - 0rem);
              width: calc((100vh - 0rem) / ${imageRatio});
              max-height: 62rem;
              max-width: calc(62rem / ${imageRatio});
            }
            .imageContainer {
              padding-bottom: 0;
              min-height: ${36 + 12 - py}rem;
              min-width: calc(${36 + 12 - py}rem / ${imageRatio});

              --height: calc(100vh - ${py}rem);
              height: var(--height);
              width: calc(var(--height) / ${imageRatio});

              max-height: 40rem;
              max-width: calc(40rem / ${imageRatio});
            }
          }
        `}
      </style>
    </>
  )
}
